export const checkForEinvoiceEligibility = () => {
  return (dispatch, getState, { api }) => {
    return api.checkForEinvoiceEligibility().then(
      ({ result }) => {
        return result.eligible;
      },
      (err) => {
        return false;
      },
    );
  };
};
